export type { Avatar } from "@repo/shared/types/avatar";

export { AvatarPicker } from "./avatar-picker";
export type { AvatarPickerProps, AvatarValue } from "./avatar-picker.types";
